// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-area-with-mentions { 
    position: relative;
}

.text-area-with-mentions .text-area-with-mentions__autocomplete {
    position: absolute;
    text-align: left;
    background-color: white; 
    border: thin solid var(--floating-menu-border-color);
    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    padding: 5px 0;
    z-index: 1000;
    border-radius: 7px;
}
.text-area-with-mentions .text-area-with-mentions__autocomplete-item {
    display: block;
    white-space: nowrap;
    padding: 5px 20px;
}

.text-area-with-mentions .text-area-with-mentions__suggestions {
    position: absolute;
    text-align: left;
    background-color: white; 
    border: thin solid var(--floating-menu-border-color);
    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    padding: 5px 0;
    z-index: 1000;
    border-radius: 7px;
}
.text-area-with-mentions .text-area-with-mentions__suggestions a {
    display: block;
    color: var(--primary-color-darkest);
    padding: 5px;
}
.text-area-with-mentions .text-area-with-mentions__suggestions a:hover {
    background-color: var(--primary-color-main);
    color: white;
}
.text-area-with-mentions .text-area-with-mentions__suggestions a.highlight {
    background-color: var(--primary-color-main);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/TextAreaWithMentions/TextAreaWithMentions.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,oDAAoD;IACpD,6CAA6C;IAC7C,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,oDAAoD;IACpD,6CAA6C;IAC7C,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,2CAA2C;IAC3C,YAAY;AAChB;AACA;IACI,2CAA2C;IAC3C,YAAY;AAChB","sourcesContent":[".text-area-with-mentions { \n    position: relative;\n}\n\n.text-area-with-mentions .text-area-with-mentions__autocomplete {\n    position: absolute;\n    text-align: left;\n    background-color: white; \n    border: thin solid var(--floating-menu-border-color);\n    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    padding: 5px 0;\n    z-index: 1000;\n    border-radius: 7px;\n}\n.text-area-with-mentions .text-area-with-mentions__autocomplete-item {\n    display: block;\n    white-space: nowrap;\n    padding: 5px 20px;\n}\n\n.text-area-with-mentions .text-area-with-mentions__suggestions {\n    position: absolute;\n    text-align: left;\n    background-color: white; \n    border: thin solid var(--floating-menu-border-color);\n    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    padding: 5px 0;\n    z-index: 1000;\n    border-radius: 7px;\n}\n.text-area-with-mentions .text-area-with-mentions__suggestions a {\n    display: block;\n    color: var(--primary-color-darkest);\n    padding: 5px;\n}\n.text-area-with-mentions .text-area-with-mentions__suggestions a:hover {\n    background-color: var(--primary-color-main);\n    color: white;\n}\n.text-area-with-mentions .text-area-with-mentions__suggestions a.highlight {\n    background-color: var(--primary-color-main);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
